import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content border-0 rounded-3" }
const _hoisted_3 = { class: "modal-header border-bottom" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = { class: "modal-title mb-0" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "rounded-3 p-3 mb-3 d-flex justify-content-between align-items-center payhist-void-summary"
}
const _hoisted_8 = { class: "payhist-period-pill" }
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "modal-footer border-0" }
const _hoisted_13 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_16 = {
  key: 1,
  class: "fas fa-ban me-1"
}

import { onMounted, ref, Ref } from 'vue'
import { Modal } from 'bootstrap'
import DriverRepository from '@/repositories/DriverRepository'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'
import { MonthlyPaymentInterface } from '@/types/MonthlyPaymentInterface'


export default /*@__PURE__*/_defineComponent({
  __name: 'VoidMonthlyPaymentModal',
  props: {
    driverId: {}
  },
  emits: ["voided", "error"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const modalEl = ref<HTMLElement | null>(null)
let modalInstance: Modal | null = null

const voidingPayment: Ref<MonthlyPaymentInterface | null> = ref(null)
const voidReason = ref('')
const submittingVoid = ref(false)
const activeDriverId = ref<string | undefined>(undefined)

function open(payment: MonthlyPaymentInterface, driverId?: string): void {
  voidingPayment.value = payment
  voidReason.value = ''
  activeDriverId.value = driverId ?? props.driverId
  const el = modalEl.value
  if (!el) return
  modalInstance = Modal.getOrCreateInstance(el)
  modalInstance.show()
}

__expose({ open })

onMounted(() => {
  const el = modalEl.value
  if (el) {
    el.addEventListener('hidden.bs.modal', () => {
      voidingPayment.value = null
      voidReason.value = ''
    })
  }
})

async function confirmVoidPayment(): Promise<void> {
  const payment = voidingPayment.value
  const driverId = activeDriverId.value
  if (!payment || !driverId || !voidReason.value.trim()) return
  submittingVoid.value = true
  try {
    await DriverRepository.voidMonthlyPayment(driverId, payment.id, voidReason.value.trim())
    modalInstance?.hide()
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
    emit('voided', payment)
  } catch (e: any) {
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
    emit('error', e)
  } finally {
    submittingVoid.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "void-monthly-payment-modal",
    ref_key: "modalEl",
    ref: modalEl,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "modal-icon-chip modal-icon-chip-danger" }, [
              _createElementVNode("em", { class: "fas fa-ban" })
            ], -1)),
            _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t('drivers.monthly_payments.void_modal_title')), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (voidingPayment.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(voidingPayment.value.period), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString((voidingPayment.value.amount ?? 0).toLocaleString('es-CO') + ' COP'), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.field_void_reason')), 1),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control mt-1",
              rows: "3",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((voidReason).value = $event)),
              placeholder: _ctx.$t('drivers.monthly_payments.placeholder_void_reason')
            }, null, 8, _hoisted_11), [
              [_vModelText, voidReason.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
          _createElementVNode("button", {
            onClick: confirmVoidPayment,
            type: "button",
            class: "btn bg-gradient-danger",
            disabled: !voidReason.value.trim() || submittingVoid.value
          }, [
            (submittingVoid.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
              : (_openBlock(), _createElementBlock("em", _hoisted_16)),
            _createTextVNode(_toDisplayString(_ctx.$t('drivers.monthly_payments.action_void_confirm')), 1)
          ], 8, _hoisted_14)
        ])
      ])
    ])
  ], 512))
}
}

})